module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user-profile/user-profile.component.css
// module id = ./src/app/user-profile/user-profile.component.css
// module chunks = main